import actionTypes from '../constants/action-types';

const deleteCustomColorPalette = (id) => ({
  type: actionTypes.DELETE_CUSTOM_COLOR_PALETTE,
  payload: {
    id,
  },
});

export default deleteCustomColorPalette;
